export const purchaseOfferStates = [
  {
    label: ' خرید این محصول رو توصیه میکنم',
    icon: 'Like',
    value: 1,
    type: 'fill',
  },
  {
    label: 'خرید این محصول رو توصیه نمی کنم',
    icon: 'Dislike',
    value: 0,
    type: 'stroke',
  },
  {
    label: ' درباره خرید این کالا مطمئن نیستم',
    icon: 'QuestionWrap',
    value: 2,
  },
];
